var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcGuideWifi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18 3.80823L16.41 5.43706C14.5125 3.49471 11.8875 2.29412 9 2.29412C6.1125 2.29412 3.4875 3.49471 1.59 5.43706L0 3.80823C2.3025 1.45294 5.4825 0 9 0C12.5175 0 15.6975 1.45294 18 3.80823ZM3.18 7.05059L4.77 8.67177C5.85 7.57059 7.35 6.88235 9 6.88235C10.65 6.88235 12.15 7.57059 13.23 8.67941L14.82 7.05824C13.335 5.52882 11.2725 4.58824 9 4.58824C6.7275 4.58824 4.665 5.52882 3.18 7.05059ZM9 9.17647C7.965 9.17647 7.0275 9.60471 6.3525 10.2929L9 13L11.6475 10.2929C10.9725 9.60471 10.035 9.17647 9 9.17647Z",
    fill: "#5E42E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGuideWifi);
export default __webpack_public_path__ + "static/media/ic_guide_wifi.b5317ca3981f7720a20d296ac3f6cc8a.svg";
export { ForwardRef as ReactComponent };